<template>
  <div id="dev-slider" class="dev-slider">
    <b-button size="sm" v-b-toggle.sidebar-1 v-if="devTool != 'false' && devTool" class="dev-tool"> DEV-TOOL </b-button>
    <b-sidebar id="sidebar-1" title="DEV-TOOL" shadow v-if="devTool">
      <b-container class="dev-tools">
        <b-row cols="12" align-v="start">
          <b-form-input type="text" v-model="gameId" placeholder="Wpisz ID" style="z-index: 5"></b-form-input>
        </b-row>
        <b-row cols="12" align-v="start"> Lista gier: </b-row>
        <b-row cols="12" align-h="center">
          <b-button-group vertical class="game-list" fluid>
            <b-button
              variant="outline-primary"
              size="sm"
              cols="10"
              class="game-button"
              v-for="game of games"
              @click="openGame(game)"
              :key="`game_${game.id}`"
            >
              <span>{{ game.id }}</span>
            </b-button>
          </b-button-group>
        </b-row>
      </b-container>
    </b-sidebar>
  </div>
</template>

<script>
export default {
  name: 'dev-sidebar',
  props: {
    multibookType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      gameId: '',
    };
  },
  methods: {
    openGame(game) {
      this.$router.push({
        name: 'game',
        params: { id: game.id, multibookType: `${this.$store.getters.multibookType}` },
      });
    },
  },
  computed: {
    devTool() {
      return this.$store.getters.devTool;
    },
    games() {
      return this.allGames.filter((game) => {
        return game.id.includes(this.gameId.toLowerCase());
      });
    },
    allGames() {
      let gamesMap = this.$store.getters[`${this.multibookType}/games`];
      let games = [];
      for (const [id, game] of new Map([...gamesMap.entries()].sort())) {
        games.push(game);
      }
      return games;
    },
  },
};
</script>

<style lang="scss" scoped>
$devColor: #0d7ebe;
.dev-slider {
  width: 17vh;
  height: 100%;
  position: absolute;
  .dev-tool {
    font-weight: bold;
    background-color: $devColor;
    top: 50%;
    left: -32px;
    transform: rotate(-90deg);
    position: fixed !important;
  }
  .sidebar-title {
    background-color: $devColor;
    color: white;
  }
  .game-list {
    width: 80%;
    .game-button {
      font-weight: bold;
      background-color: $devColor;
      color: white;
      padding-bottom: 1px;
    }
  }
}
</style>
